import useDeleteData from '../../../../hooks/deleteHook';

export const useRemoveAttachment = (route, productId, attachmentId) => {
  const [{ params, isLoading, isError, error }, doRemoveAttachment] =
    useDeleteData(`${route}/${productId}/attachment/${attachmentId}`);

  return { params, isLoading, isError, error, doRemoveAttachment };
};
